// import
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  holdRequestToggle,
  requestId,
  requestList,
} from "../../state/atom/request";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { Http } from "../../utility/http";
import { apiHeaders } from "../../utility/generic";
import { toaster } from "../../state/atom/toaster";

// Component displaying a hold request confirmation.
export const HoldRequest = () => {
  // states and hooks
  const reqId = useRecoilValue(requestId);
  const [holdReqToggle, setHoldRequestToggle] =
    useRecoilState(holdRequestToggle);
  const setToasterStatus = useSetRecoilState(toaster);
  const setRequestList = useSetRecoilState(requestList);

  // Handles the user confirmation when the user click on Yes button.
  const holdRequest = () => {
    // Payload for API
    const request = {
      requestStatus: "hold",
    };

    // Make the POST request for the hold the request.
    Http.request(
      "patch",
      `${process.env.REACT_APP_API_URL}land-request/${reqId}`,
      request,
      apiHeaders()
    )
      .then((result: any) => {
        setRequestList((preState) => {
          let preRequest = [...preState.data.landRequest];
          const index = preRequest.findIndex((val: any) => val.id === reqId);
          //@ts-ignore
          preRequest[index].status = request.requestStatus;
          return {
            ...preState,
            landRequest: preRequest,
          };
        });

        //Show a success notification to the user
        setToasterStatus({
          status: true,
          title: "Request",
          text: "Land request on hold placed successfully",
        });

        // hide the hold request confirmation box.
        setHoldRequestToggle(!holdReqToggle);
      })
      .catch((error: any) => {});
  };

  return (
    <div
      className="modal show"
      style={{ display: "block", position: "initial" }}
    >
      <Modal
        show={holdReqToggle}
        onHide={() => setHoldRequestToggle(!holdReqToggle)}
      >
        <Modal.Header closeButton className="toaster-header ">
          <Modal.Title>Hold Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure want to hold this request!</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setHoldRequestToggle(!holdReqToggle)}
          >
            Cancel
          </Button>
          <Button onClick={holdRequest} variant="primary">
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
